/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const factory = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.385 12.75h2m2.348 0h2M6.003.83C6.691.817 7.373.96 8 1.243c4.953 2.114 7-.494 7-.494m-1.237 6.884c.242.15.196.208.237.283v6.833a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-5.5s1.495-7 1.904-7h1.192c.237 0 1.904 7 1.904 7s3.431-1.638 3.763-1.616C9.843 7.64 10 9.25 10 9.25s3.52-1.766 3.763-1.616Z"
    />
  </svg>
)
export default factory
